module.exports = __webpack_public_path__ + "static/media/LG-G6.0e03fb5f.png";